import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";
import { limitWords } from "@utils/limitWords";

const ACTIVATEMESSAGE = gql`
   mutation updateMessage($id: ID!, $updateInput: UpdateMessageInput!){
    updateMessage(id: $id, updateInput: $updateInput)
  }
`;
function ActivateMessage({ id, title, children, onActivateMessage }) {
    const [runActivateMessage, setActivateMessage] = useMutation(ACTIVATEMESSAGE, {
        onCompleted({ updateMessage }) {
            message.success(` پیام ${title ? limitWords(title, 5) : ""} فعال شد.`);
            onActivateMessage();
        },
        onError() {
            message.error("متاسفانه مشکلی پیش آمده!پیام فعال نشد.");
        },
    });
    const doActivateMessage = () => {
        runActivateMessage({
            variables: { id, updateInput: { isActive: true } },
        });
    };
    return (
        <>
            <Popconfirm
                title={`فعال کردن ${title ? "پیام " + limitWords(title, 5) : "پیام"}?`}
                okText="فعال کردن"
                cancelText="خیر"
                onConfirm={doActivateMessage}
            >
                <span>{children}</span>
            </Popconfirm>
        </>
    );
}

export default ActivateMessage;